<template>

  <div class="workflow-content">

    <edit-workflow :row-data="rowData" :site-id="siteId" />

    <el-card shadow="hover" v-if="rowData.totalFiles > 0">
      <div slot="header" class="clearfix">
    <span><h3>Files</h3></span>

    <good-table
      :cols="[{label: 'File Name', field: 'file'}, {label: 'Party No.', field: 'partyNo'}]"
      :rows="rowData.requiredFiles.files"
     />

  </div>
    </el-card>

    <br />

    <el-card shadow="hover">
      <checklist-table :parent-data="rowData" />
    </el-card>

  </div>
</template>

<script>

import ChecklistTable from '@/components/workflow/checklist/ChecklistTable'
import EditWorkflow from '@/components/workflow/EditWorkflow'

export default {
  name: 'workflow-details',

  components: {
    ChecklistTable,
    EditWorkflow
  },

  props: {
    rowData: {
      type: Object,
      required: true

    },

    rowIndex: {
      type: Number
    },

    siteId: {
      type: Number,
      default: null
    }
  },

  data () {
    return {
      formData: [],
      isSite: this.siteId ? true : false
    }
  }
}
</script>

<style scoped>

.workflow-content {
  border-radius: 2em;
  background-color: #ECF5FF88;
  padding-left: 2em;
  padding-right: 2em;
  padding-bottom: 2em;
}

</style>
